module.exports = __webpack_public_path__ + "static/media/sales2.b8219cb8.png";